var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulkEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.998,
    height: 15,
    viewBox: "0 0 14.998 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11965",
    "data-name": "Path 11965",
    d: "M4.9,2.653h8.826a2.162,2.162,0,0,0,1.636-.606,2.5,2.5,0,0,0,.583-1.8V-7.776L14.589-6.42V.148A1.213,1.213,0,0,1,14.322,1a.855.855,0,0,1-.65.287H4.949A1.138,1.138,0,0,1,4.115,1,1.149,1.149,0,0,1,3.824.148V-8.327a1.149,1.149,0,0,1,.291-.854,1.138,1.138,0,0,1,.834-.287H11.6l1.357-1.357H4.9a2.484,2.484,0,0,0-1.815.6,2.423,2.423,0,0,0-.61,1.8V.251a2.426,2.426,0,0,0,.61,1.8A2.473,2.473,0,0,0,4.9,2.653ZM7.7-2.326l1.508-.646,6.95-6.942L15.06-11,8.117-4.058,7.439-2.6a.176.176,0,0,0,.044.215A.188.188,0,0,0,7.7-2.326Zm9.009-8.139.559-.575a.705.705,0,0,0,.2-.479.646.646,0,0,0-.2-.471l-.184-.184a.535.535,0,0,0-.447-.172.715.715,0,0,0-.463.219l-.567.559Z",
    transform: "translate(-2.476 12.347)",
    fill: "#5dadae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkEdit);
export default __webpack_public_path__ + "static/media/bulk-edit.e990f424db3acdc4106e6e0e80502c28.svg";
export { ForwardRef as ReactComponent };